var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 234,
    viewBox: "0 0 211 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.262 109.243C165.426 89.641 137.774 51.3838 118.039 43.1466C94.7493 33.426 86.501 46.0622 85.0454 65.5028C85.3689 79.759 92.4203 117.02 118.039 152.012M176.262 118.963C190.817 89.801 197.125 33.1338 166.073 39.7434C135.02 46.3531 106.07 96.1208 93.7789 121.393",
    stroke: "url(#paint0_linear_2678_20804)",
    strokeWidth: 0.485192
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.286 80.0803C45.2578 80.0803 33.1287 127.223 84.0743 141.803C94.1015 144.233 118.717 149.287 136.96 150.065",
    stroke: "url(#paint1_linear_2678_20804)",
    strokeWidth: 0.485192
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.266 68.561C200.457 77.1929 206.62 98.6784 196.046 116.67C189.442 127.907 182.836 135.312 175.51 141.057C168.188 146.799 160.154 150.877 150.714 155.464C142.482 159.465 112.145 169.07 79.8633 158.995C62.913 153.704 52.414 145.542 45.7832 136.815C39.1545 128.091 36.4029 118.818 34.9229 111.324L35.3477 111.215C35.9956 113.276 37.5148 115.733 39.5908 118.366C41.6639 120.994 44.2799 123.782 47.1035 126.5C52.7466 131.934 59.2061 137.08 63.791 140.121C70.9511 143.777 89.8135 150.821 108.02 149.769C119.424 149.11 127.857 147.683 136.013 144.997C144.171 142.309 152.06 138.359 162.377 132.642C182.953 121.24 188.636 107.662 194.349 97.5376C196.606 93.5378 197.446 88.0098 197.734 82.6128C198.024 77.2061 197.759 72.0129 197.833 68.6099L198.266 68.561Z",
    fill: "#C6C5CA",
    stroke: "white",
    strokeWidth: 0.439122
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6611 156.149L59.9278 152.016C61.4912 150.038 62.2729 149.049 63.2071 148.535C64.471 147.84 65.9645 147.694 67.3394 148.13C68.3555 148.452 69.3146 149.27 71.2326 150.907C72.9831 152.401 73.8584 153.148 74.328 154.027C74.9634 155.218 75.118 156.606 74.7599 157.907C74.4952 158.869 73.8056 159.79 72.4264 161.632L68.9566 166.266L56.6611 156.149Z",
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 0.175649
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.618 155.822C52.8302 154.37 54.9882 154.177 56.4383 155.391L70.0111 166.759C71.4612 167.973 71.6547 170.135 70.4428 171.588L18.9484 233.279L0.123702 217.513L51.618 155.822Z",
    fill: "url(#paint2_linear_2678_20804)",
    stroke: "url(#paint3_linear_2678_20804)",
    strokeWidth: 0.175649
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint4_angular_2678_20804_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.00219561 -0.00747757 0.014158 -0.00417107 118.219 18.8616)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: -13427.5,
    y: -13427.5,
    width: 26855,
    height: 26855
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      background: "conic-gradient(from 90deg,rgba(32, 32, 32, 0.06) 0deg,rgba(217, 217, 217, 0) 360deg)",
      height: "100%",
      width: "100%",
      opacity: 1
    }
  })))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3464 104.634C35.6637 91.7314 47.0469 63.509 62.8893 52.2911C88.3584 34.2568 97.1408 34.0069 103.289 32.4976C118.219 28.8321 145.444 24.14 169.596 39.0954C188.497 50.7993 194.333 72.8177 195.943 80.8818C196.968 73.844 196.99 59.2015 194.531 54.9789C191.457 49.7006 171.697 26.8281 163.009 22.8207C153.758 18.5531 107.241 9.62495 78.6977 26.7794C50.1548 43.9338 35.5688 66.855 33.8124 75.2123C32.1382 83.1785 33.3217 97.4495 34.3464 104.634Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_ANGULAR\",\"stops\":[{\"color\":{\"r\":0.12865397334098816,\"g\":0.12865397334098816,\"b\":0.12865397334098816,\"a\":0.059999998658895493},\"position\":0.0},{\"color\":{\"r\":0.85098040103912354,\"g\":0.85098040103912354,\"b\":0.85098040103912354,\"a\":0.0},\"position\":1.0}],\"stopsVar\":[],\"transform\":{\"m00\":-4.3912177085876465,\"m01\":28.315935134887695,\"m02\":106.25639343261719,\"m10\":-14.955135345458984,\"m11\":-8.3421459197998047,\"m12\":30.510265350341797},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M98.1553 19.9736C142.502 8.13674 186.471 26.3658 195.819 61.5054C205.167 96.6452 176.085 134.374 131.738 146.211C87.3906 158.048 43.4209 139.818 34.0727 104.678C24.7249 69.5386 53.8082 31.8106 98.1553 19.9736Z",
    stroke: "white",
    strokeWidth: 2.63473
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint4_angular_2678_20804_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3464 104.634C35.6637 91.7314 47.0469 63.509 62.8893 52.2911C88.3584 34.2568 97.1408 34.0069 103.289 32.4976C118.219 28.8321 145.444 24.14 169.596 39.0954C188.497 50.7993 194.333 72.8177 195.943 80.8818C196.968 73.844 196.99 59.2015 194.531 54.9789C191.457 49.7006 171.697 26.8281 163.009 22.8207C153.758 18.5531 107.241 9.62495 78.6977 26.7794C50.1548 43.9338 35.5688 66.855 33.8124 75.2123C32.1382 83.1785 33.3217 97.4495 34.3464 104.634Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2678_20804",
    x1: 168.499,
    y1: -54.5423,
    x2: 136.569,
    y2: 151.996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF9D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF9D61",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2678_20804",
    x1: 79.222,
    y1: 163.673,
    x2: 95.7703,
    y2: 100.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CF9D61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF9D61",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2678_20804",
    x1: 66.7564,
    y1: 153.069,
    x2: 6.37685,
    y2: 222.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDEEED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEEED",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2678_20804",
    x1: 61.0478,
    y1: 161.866,
    x2: 15.7337,
    y2: 212.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e95bf94b6e458d3a7ad52a364412fb93.svg";
export { ForwardRef as ReactComponent };